// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Role enum
/**
 * Workspace role
 * */
export var UserRole;
(function (UserRole) {
    UserRole["owner"] = "Owner";
    UserRole["admin"] = "Admin";
    UserRole["creator"] = "Creator";
    UserRole["contributor"] = "Contributor";
    UserRole["billing"] = "Billing";
    UserRole["viewer"] = "Viewer";
})(UserRole || (UserRole = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Utilities
export const remoteRoleToUserRole = {
    Owner: UserRole.owner,
    Admin: UserRole.admin,
    Creator: UserRole.creator,
    Contributor: UserRole.contributor,
    Billing: UserRole.billing,
    Viewer: UserRole.viewer,
};
